
export const AboutUs = () => {
    return (
        <>
            <div className="row  px-lg-5 pb-5 align-items-center" id="About" >

                <div className="col-12 col-lg-6 p-4">

                    <h2 className=" fw-bold green" style={{ fontSize: '26px' }}>
                        ABOUT  <span className="gray_color" >MILSO</span> </h2>
                    <div className="col-8 col-lg-3  zoom-in-out-box2 text-center">
                        <hr />
                    </div>
                    <p className="  pt-4" style={{ textAlign: 'justify', fontSize:'18px' }} >
                        {/* MILSO is the On-line learning and sharing platform for the various topic related to the marine insurance which includes the Hull and Machinery insurance, cargo insurance, Loss of Hire Insurance, Builders Risks insurance and marine off shore insurance. Marine insurance is the oldest branch of insurance and has it uniqueness and glory while practically dealing with the subject. Theory and practice not always go hand in hand and the maritime stakeholders do face certain issued when it comes to implementation level. Industry expertise at MILSO will provide complete hand holding of its clients to achieve the “win win” situation for all the parties. */}
                        MILSO is the on-line learning and sharing platform for the various topics related to the Marine Insurance which includes the Hull and Machinery Insurance, Cargo Insurance, Loss of Hire Insurance, Builders’ Risks Insurance and Oil & Gas (Energy) Insurance. Marine Insurance is the oldest branch of insurance which is unique with its subtilities and nuances.Theory and practice when intertwined assist stakeholders in the maritime and insurance industries to face the present day challenges. MILSO strives to assist all stakeholder to face the challenges of volatility, uncertainty, chaos and ambiguity, with “win-win” solutions. 
                    </p>
                    {/* <div className="row pt-4  p-3 p-lg-0">
                        <div className="col-12 col-lg-3 py-2">
                            <div className="faint_bg p-4 rounded border border-1 border-success text-center">
                                <h2 className=" fw-bold">  25 K +</h2>
                                <span className="fw-bold green">   Years Experience</span>
                            </div>
                        </div>

                        <div className="col-12 col-lg-3 py-2">
                            <div className="faint_bg p-4 rounded border border-1 border-success text-center">
                                <h2 className=" fw-bold">  60 K +</h2>
                                <span className="fw-bold green">      Agriculture Products</span>
                            </div>
                        </div>

                        <div className="col-12 col-lg-3 py-2">
                            <div className="faint_bg p-4 rounded border border-1 border-success text-center">
                                <h2 className=" fw-bold">  20 K +</h2>
                                <span className="fw-bold green">      Satisfied Customers</span>
                            </div>
                        </div>

                        <div className="col-12 col-lg-3 py-2">
                            <div className="faint_bg p-4 rounded border border-1 border-success text-center">
                                <h2 className=" fw-bold">  20 K +</h2>
                                <span className="fw-bold green">Countries</span>
                            </div>
                        </div>



                    </div> */}

                </div>

                <div className="col-12 col-lg-6  px-4 bounce d-flex justify-content-center " id="hover_effect" >
                    <img src="Static/Assets/Img/services/1milso.jpg" className="Marine_insurance shadow2" alt="" />
                </div>

            </div>



        </>
    )
}
